export enum rdeKeylengthEnum {
    Single = 1,
    Double = 2
}

export namespace rdeKeylengthEnum {
    export function values() {
        return Object.keys(rdeKeylengthEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
